import { TFunction } from 'i18next';

export enum ProjectStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PAUSED = 'paused',
}

export const projectStatusOptions: ProjectStatus[] = [
  ProjectStatus.ACTIVE,
  ProjectStatus.INACTIVE,
  ProjectStatus.PAUSED,
];

export function getProjectStatusDisplay({
  status,
  t,
}: {
  status?: ProjectStatus | null;
  t: TFunction<'shared', 'Filter'>;
}): string {
  switch (status) {
    case ProjectStatus.ACTIVE:
      return t('active');
    case ProjectStatus.INACTIVE:
      return t('inactive');
    case ProjectStatus.PAUSED:
      return t('paused');
    case undefined:
    case null:
      return '';
  }
}
